import React, { FC } from "react"
import styled from "styled-components"
import Button from "../../../components/ui/button"
import { toRem } from "../../../utils/styles-function"
import { SearchIcon } from "ui-kit-sber/dist/js/components/Icons"
import { WalletIcon } from "./WalletIcon"
import { UserIcon } from "./UserIcon"
import { BurgerIcon } from "./BurgerIcon"

const NavLinks = styled.div`
  ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  li {
    &:first-child {
      a {
        color: #878b90;
        font-weight: normal;
      }
    }
    a {
      font-family: SB Sans Interface, serif;
      display: flex;
      align-items: center;
      font-size: ${toRem(13)};
      line-height: ${toRem(15)};
      font-feature-settings: "pnum" on, "lnum" on;
      color: #21a038;
      font-weight: 600;
      text-decoration: none !important;

      &:hover {
        opacity: 0.825;
      }

      svg {
        margin-right: 8px;
      }
    }
  }
`

const MenuStyles = styled(NavLinks)`
  @media screen and (max-width: 1023px) {
    display: none;
  }
`

const MenuStylesMobile = styled(NavLinks)`
  display: flex;
  justify-content: flex-end;
  li:not(:last-child) {
    margin-right: 10px;
  }
  @media screen and (min-width: 1023px) {
    display: none;
  }
`

interface IHeaderMenu {
  onBurgerClick: () => void
  onSearchClick: () => void
}

export const HeaderMenu: FC<IHeaderMenu> = ({
  onBurgerClick,
  onSearchClick,
}) => {
  return (
    <>
      <MenuStyles>
        <ul>
          <li>
            <a href="https://npfsberbanka.ru/about/information-to-be-disclosed/">
              Раскрытие информации
            </a>
          </li>
          <li>
            <a
              href="https://lk.npfsb.ru/payment?_ga=2.90780698.103920865.1603875270-884543250.1602498595"
              target="_blank"
            >
              <WalletIcon />
              Внести платеж
            </a>
          </li>
          <li>
            <a
              href="https://lk.npfsb.ru/login?_ga=2.90780698.103920865.1603875270-884543250.1602498595"
              target="_blank"
            >
              <UserIcon />
              Личный кабинет
            </a>
          </li>
          <li>
            <a
              href="https://npo.npfsb.ru/?landing=npo&step=1&_ga=2.90780698.103920865.1603875270-884543250.1602498595"
              target="_blank"
            >
              <Button>Оформить договор</Button>
            </a>
          </li>
          <li>
            <a href="#" onClick={onSearchClick}>
              <SearchIcon />
            </a>
          </li>
        </ul>
      </MenuStyles>
      <MenuStylesMobile>
        <ul>
          <li>
            <a
              href="https://lk.npfsb.ru/payment?_ga=2.200448745.619783962.1601534253-219076345.1566484439"
              target="_blank"
            >
              <WalletIcon />
            </a>
          </li>
          <li>
            <a
              href="https://lk.npfsb.ru/login?_ga=2.120732239.619783962.1601534253-219076345.1566484439"
              target="_blank"
            >
              <UserIcon />
            </a>
          </li>
          <li>
            <a href="#" onClick={onBurgerClick}>
              <BurgerIcon />
            </a>
          </li>
        </ul>
      </MenuStylesMobile>
    </>
  )
}
